import React, { useState } from "react";
import { motion } from "framer-motion";
import SlackIntegration from "../../helpers/SlackIntegration.js";
import "./AskUsAndSupport.css";

export default function ContactAndSupport(){
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [actionRequested, setActionRequested] = useState('contact_dev');
    const [userNeedsUpdate, setUserNeedsUpdate] = useState('no');
    const [userEmail, setUserEmail] = useState('');
    const [userComments, setUserComments] = useState('');

    const validateEmail = (email) => {
        var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
        return String(email).search (filter) !== -1;
    }

    const validateAndProcessRequest = async () => {
        if(!userEmail || !validateEmail(userEmail) || !userComments || userComments.length < 20){
            return false;
        }

        const issueObj = {
            description: "Bugs & Issues for IoWT Reported by " + userEmail,
            summary: userComments,
            userEmail: userEmail,
            canContact: userNeedsUpdate
        }
        
        setIsProcessing(true);

        // Post to Slack
        var slackResponse = await postToSlack(issueObj);
        if(slackResponse == 'ok'){
            setIsSubmitted(true);
            setErrorMessage('');
        } else {
            setIsSubmitted(false);
            setErrorMessage('Failed to post to our Slack channel, please try again later :( \n' + slackResponse);
        }

        setIsProcessing(false);
    }

    const postToSlack = async (issueObj) => {
        return await SlackIntegration.postCommentToChannel(issueObj);
    }

    return (
        <main className="content">
            <div className="tabcontent">
                <div className="shadow-sm p-3 rounded">
                    <div className="fs-3 mb-3" id="menu">
                         <strong>Ask Us & Support</strong>
                    </div>

                    <br/>
                    <form style={{width:"95%"}}>
                        <div className="mb-3">
                            <span>What would you like to do?</span>
                            <select className="form-select" 
                                    value={actionRequested}
                                    onChange={(event)=>{
                                        setActionRequested(event.target.value);
                                        console.log(actionRequested);
                                    }}>
                                <option value="contact_dev">Ask the IoWT Dev Anything</option>
                                <option value="report_issue">Report Bugs & Issues</option>
                            </select>

                        </div>
                        <div className="mb-3">
                            <span>Email address</span>
                            <input type="email" className="form-control" 
                                    onChange={(event) => {
                                        var email = event.target.value;
                                        setUserEmail(email);
                                        validateEmail(email);
                                    }}/>
                            <p className={(!validateEmail(userEmail) && userEmail !== '') ? "support-form-info-message errorCode" : "support-form-info-message"}>
                                {(!validateEmail(userEmail) && userEmail !== '') ? "Please enter a valid email address" : "We'll never share your email with anyone else, we promise"}
                            </p>
                        </div>

                        <div className="mb-3">
                            <span>
                                {actionRequested === 'contact_dev' ? "Would you like us to reach back out to you?" : "Would you like updates on the issues you are about to submit?"}
                            </span>
                            <select className="form-select" 
                                    value={userNeedsUpdate}
                                    onChange={(event)=>{
                                        setUserNeedsUpdate(event.target.value);
                                    }}>
                                <option value="yes">Yes, please!</option>
                                <option value="no">Nope, never!</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <span>{actionRequested === 'contact_dev' ? "What's up? 😎" : "Please provide details on the issues"}</span>
                            <textarea 
                                className="form-control support-form-feedback-textarea"
                                value={userComments}
                                onChange={(event)=>{
                                    setUserComments(event.target.value);
                                }}
                            />
                            <p className={ (userComments !== '' && userComments.length < 20) ? "support-form-info-message errorCode" : "support-form-info-message"}>
                                { (userComments !== '' && userComments.length < 20) ? "Please enter more than 20 chars" : ''}
                            </p>
                        </div>


                        <div className="row">
                            <div className="col"><motion.button 
                                disabled={isProcessing ? true : false}
                                type="button"
                                className="button the-support-button"
                                whileHover={isProcessing ? { scale: 1 } : { scale: 1.1 }}
                                whileTap={isProcessing ? { scale: 1 } : { scale: 0.8 }}
                                onClick={ () => { validateAndProcessRequest() }}
                                onTouchEnd={ () => { validateAndProcessRequest() }}
                                >{isProcessing ? "Processing..." : "Submit"}
                            </motion.button></div>
                            <div className="col"><div className={isProcessing ? "loader" : "toHide"}/></div>
                        </div>


                        <div className={isProcessing || isSubmitted ? "toHide" : "message-card"}>
                            <h5>What's next?</h5>
            
                            After clicking on submit, your message will be posted to our Slack channel. 
                            {actionRequested === 'contact_dev' ? 
                            " We look forward to hearing from you. Thank you for contacting us!"
                            : " We'll try our best to investigate and fix the potential issues. Thank you for your feedback!"}
                            
                            {userNeedsUpdate === 'yes' ? " We'll stay in touch! Please be on the lookout for an email from dev@iowt-now.com" : ''}
                        </div>

                        <div className={isProcessing || isSubmitted || errorMessage ? "message-card" : "toHide"}>
                                <div className={isProcessing ? "" : "toHide"}>Processing, please wait...</div>

                                <div className={actionRequested === 'contact_dev' || actionRequested === 'report_issue' && isSubmitted ? "" : "toHide"}>
                                    Success! Your messages has been posted to our Slack channel! Thank you for contacting us!
                                </div>

                                <div className={errorMessage ? "errorCode" : "toHide"}>
                                    {errorMessage}
                                </div>
                        </div>
                    </form>

                </div>
            </div>
        </main>
    );
}
